export const sources={};export const img={src:"__VITE_ASSET__tgItkVM6JTrfm2CiQnzY5g__",w:640,h:640};export default{sources:sources,img:img};